module.exports = __webpack_public_path__ + "img/lg_ring_g_c_1_1@3x.d5a2607f.png";